import { Box, Text } from '@nimbus-ds/components';
import { TFunction } from 'i18next';
import { Country, CurrencyType, PaymentResponseDto } from '@tiendanube/common';
import PaymentMethodDetail from './PaymentMethodDetail';

interface PaymentDetailsProps {
  payments: PaymentResponseDto[];
  currency: CurrencyType;
  t: TFunction;
  openGatewayLink: (gatewayLink: string) => void;
  rejectedPaymentInfo: string;
  isDesktop: boolean;
  isNuvemPagoPayment: boolean;
  onNuvemPagoRedirect: () => void;
  country: Country;
  isMobile: boolean;
  openNuvemPago: () => void;
}

function PaymentDetails({
  payments,
  currency,
  t,
  openGatewayLink,
  rejectedPaymentInfo,
  isDesktop,
  isNuvemPagoPayment,
  onNuvemPagoRedirect,
  country,
  isMobile,
  openNuvemPago,
}: Readonly<PaymentDetailsProps>): JSX.Element {
  const isMultiplePayments = (payments?.length ?? 0) > 1;

  return (
    <Box>
      <Box paddingBottom="2">
        <Text fontWeight="bold" color="neutral-textHigh">
          {isMultiplePayments
            ? `${t('cardPayment.multiplePaymentsType')}`
            : `${t('cardPayment.paymentType')}`}
        </Text>
      </Box>
      <Box>
        {payments?.map((payment, key) => (
          <PaymentMethodDetail
            key={key}
            payment={payment}
            currency={currency}
            t={t}
            openGatewayLink={openGatewayLink}
            rejectedPaymentInfo={rejectedPaymentInfo}
            isMultiplePayments={isMultiplePayments}
            isDesktop={isDesktop}
            isNuvemPagoPayment={isNuvemPagoPayment}
            onNuvemPagoRedirect={onNuvemPagoRedirect}
            country={country}
            isMobile={isMobile}
            openNuvemPago={openNuvemPago}
          />
        ))}
      </Box>
    </Box>
  );
}

export default PaymentDetails;
